import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ul class=\"menu-links\">\n  {{ yield (hash menu-link=this.menuLinkClass) }}\n</ul>\n")